import { Component, Signal, inject, output } from '@angular/core';
import { OAuthService } from '../services/o-auth.service';

@Component({
  selector: 'app-filter-snapshot-learn-more-dialog',
  imports: [],
  templateUrl: './filter-snapshot-learn-more-dialog.component.html',
  styleUrls: ['../common/dialogs.scss', './filter-snapshot-learn-more-dialog.component.scss'],
})
export class FilterSnapshotLearnMoreDialogComponent {
  private readonly loginService = inject(OAuthService);

  allowUsername = true;
  username: Signal<string | null> = this.loginService.userName;

  allow = output<boolean>();
  optOut = output<void>();
  close = output<void>();
}
